const productSearch = {
  filters: {
    label: 'Filtern',
    filterBy: 'Filtern nach',
    resetToDefault: 'Filter löschen',
    selectedFilters: 'Gewählte Filter',
    item: {
      categories: 'Kategorien',
      producers: 'Hersteller',
      showAll: 'Alle anzeigen',
    },
    modal: {
      productFilter: 'Produktsuchfilter',
      apply: 'Anwenden',
    },
  },
  sort: {
    productName: 'Produktname',
    popularity: 'Beliebtheit',
    sort: 'Sortieren',
    disabedSort: 'Deaktivierte Sortierung',
  },
  yourSearchResultsFor: 'Ihre Suchergebnisse für',
  allProducts: 'Alle Produkte',
  monthProductsOffer: 'Produkte des Monats',
  productsOffer: 'Unsere angebote',
  showAllProducts: 'Alle Produkte anzeigen',
  warning: {
    title: 'Produkte mit diesem Hinweis sind derzeit nur bedingt verfügbar',
    text: 'Sie können die Produkte bei Ihrer Apotheke anfragen.',
  },
  noResults: {
    searchTerm: {
      title: ' Oooops! Für Ihre Suche nach "{searchTerm}" gibt es leider keine Ergebnisse',
      tipsText: 'Tipps, die Ihnen die Suche nach Ihrem gewünschten Produkt erleichtern:',
      tips: {
        0: 'Suchen Sie gezielt nach Produktnamen, Produktkategorien und PZN.',
        1: 'Prüfen Sie, ob sich vielleicht ein Tippfehler eingeschlichen hat (z.B. „Apsirin“ statt „Aspirin“).',
        2: 'Kurze Suchbegriffe erhöhen die Trefferzahl (z.B. „Kopfschmerzen“ statt „starke Kopfschmerzen“).',
        3: 'Eventuell ist dieses Produkt im Sortiment Ihrer ausgewählten Apotheke nicht enthalten. Suchen Sie nach Alternativen oder wechseln Sie Ihre Apotheke.',
      },
      toShop: 'Zur Shopseite',
    },
    filter: {
      noProductsFound: 'Für Ihre Filter-Einstellungen wurden keine Produkte gefunden.',
      adjustSearch: 'Bitte passen Sie Ihre Suche an.',
    },
  },
}

export default productSearch
